module.exports = __webpack_public_path__ + "img/c-thermometer-img5-2.e15d9773.png";